import * as React from 'react';
import {
  ThemeProvider as StyledThemeProvider,
  createGlobalStyle,
} from 'styled-components';
import theme from '../theme';

const GlobalStyles = createGlobalStyle({
  ':root': {
    /* components/AppBar */
    '--app-bar-height': 56,
    '--app-bar-height-lg': 64,
    /* components/TabBar */
    '--tab-bar-height': 60,
  },

  '@font-face': {
    fontFamily: 'PF Benchmark Pro',
    src:
      "url('https://fonts.mybet.com/pfbenchmarkpro-bolditalic.woff2') format('woff2'), url('https://fonts.mybet.com/pfbenchmarkpro-bolditalic.woff') format('woff'), url('https://fonts.mybet.com/pfbenchmarkpro-bolditalic.ttf') format('truetype')",
    fontWeight: 'bold',
  },

  '*': {
    boxSizing: 'border-box',
    outline: 0,
  },

  body: {
    margin: 0,
    fontFamily: "'Roboto', sans-serif",
    color: '#003D59',
    backgroundColor: '#f5f8fa',
  },

  h1: {
    fontSize: '1.8em',
  },

  a: {
    textDecoration: 'none',
    color: 'inherit',
    '&:active,&:focus,&:visited,&:link': {
      textDecoration: 'none',
    },
  },

  'a, p, h1, h2, h3, h4, h5, h6, span': {
    '-webkit-font-smoothing': 'antialiased',
    marginBlockStart: 0,
    marginBlockEnd: 0,
    marginInlineStart: 0,
    marginInlineEnd: 0,
  },

  svg: {
    '-webkit-backface-visibility': 'hidden',
    '-webkit-transform': 'translateZ(0) scale(1, 1)',
    transform: 'translateZ(0)',
  },

  'input[type=text], input[type=email], input[type=password], textarea': {
    '-webkit-appearance': 'none',
  },

  'input[type=radio]': {
    position: 'absolute',
    visibility: 'hidden',
  },

  ul: {
    padding: 0,
    margin: 0,
  },
});

const KambiOverrides = createGlobalStyle`

${/** Hide "LIVE" text */ ''}

.KambiBC-event-item__live-text-container {
  display: none !important;
}

${/** Hide dropdown selector for time/league */ ''}

.KambiBC-mod-event-sort-selection {
  display: none !important;
}

${/** Aligning favorite star on games in live page */ ''}

#KambiBC-container .KambiBC-event-item__information {
  display: flex !important;
  flex: 1 0 auto !important; 
  align-items: center !important;
}


${/** Aligning number and arrow on games in live page */ ''}

#KambiBC-container .KambiBC-event-item__bet-offer-count {
  display: block !important; 
}

${/** Hiding live events on starting within routes */ ''}
[class*="starting-within"] div.KambiBC-mod-event-group-event-container:first-of-type {
  display: none !important;
}

[class*="starting-within"] div.KambiBC-mod-event-group-event-container:last-of-type {
  display: initial !important;
}

#mod-KambiBC-betslip-container .mod-KambiBC-betslip__no-selections-info {
  background: #FFF !important; 
  color: ${({ theme }): string => theme.blue13} !important;
}



.KambiBC-my-bets-logintext {
  display: none !important;
}

.KambiBC-util-route-home #KambiBC-content,
.KambiBC-util-route-home #mod-KambiBC-betslip-container {
  margin-top: 16px !important;
}

.KambiBC-reward-list-header__reward-count {
  padding-top: 12px !important; 
  padding-right: 35px !important; 
  color: #fff !important;
}

.KambiBC-date-picker__selection-wrapper {
  padding: 0 8px !important;
}

@media screen and (min-width: 960px) {
  .KambiBC-date-picker__selection-wrapper {
    padding: initial !important;
  }
}

#KambiBC-container [data-eq-state~=contentColumnMaxWidth] .KambiBC-event-groups-list {
  padding-left: 0 !important;
}

.KambiBC-container#KambiBC-container .KambiBC-betoffer-labels {
  border-top-color: ${({ theme }): string => theme.white} !important;
}

.KambiBC-container#KambiBC-container .KambiBC-betoffer-labels:first-of-type {
  border-top-width: 0 !important;
}

#KambiBC-container .KambiBC-tabs__tab_bet-builder--icon {
  display: none !important;
}

.KambiBC-container#KambiBC-container .KambiBC-landing-page-feed-card__title {
  text-transform: lowercase !important;
}
.KambiBC-container#KambiBC-container .KambiBC-landing-page-feed-card__title:first-letter {
  text-transform: uppercase !important;
}

${/** Kambi betslip overrides */ ''}
.KambiBC-checkbox {
  height: 16px !important;	
  width: 16px !important;	
  border: ${({ theme }): string => `1px solid ${theme.grey04}`} !important;
  border-radius: 2px;
  background-color: ${({ theme }): string => theme.white} !important;
  margin-right: 8px;      
}

.KambiBC-checkbox__checkbox:checked+.KambiBC-checkbox {
  height: 16px !important;	
  width: 16px !important;	
  border-radius: 2px;
  border: ${({ theme }): string => `1px solid ${theme.blue07}`} !important;
  color: ${({ theme }): string => theme.blue07};
  background-color: ${({ theme }): string => theme.white} !important;
}

.KambiBC-checkbox__checkbox:checked+.KambiBC-checkbox:after {
  top: 1px !important;
  left: 5px !important;
  width: 4px !important;
  height: 10px !important;
  border-width: 1px !important;
  color: ${({ theme }): string => theme.blue07} !important;
}
${
  /** Kambi global betslip overrides (affects only pinned mode though) - moving the betslip down on all filter pages */ ''
}
[class*="filter"] #mod-KambiBC-betslip-container.mod-KambiBC-betslip-container--pinned, [class*="bethistory"] #mod-KambiBC-betslip-container.mod-KambiBC-betslip-container--pinned  {
  margin-top: 40px;
}

[class*="in-play"] #mod-KambiBC-betslip-container.mod-KambiBC-betslip-container--pinned  {
  margin-top: 0px;
}

[data-eq-state*="layoutExtraWide"]#KambiBC-container .KambiBC-mod-event-group-filtering-options-container {
  min-height: 40px;
} 

${/** Kambi global betslip overrides - odds changing */ ''}
#mod-KambiBC-betslip-container .mod-KambiBC-betslip-outcome__odds--changing, #mod-KambiBC-betslip-container .mod-KambiBC-betslip-summary__total-odds--changing {
  background-color: ${({ theme }): string => theme.blue07}!important;
}

.mod-KambiBC-betslip__approve-odds-btn {
  ${/** initial kambi values */ ''}
  background-image: linear-gradient(#00b0f0,#038cbe) !important; 
  @media screen and (min-width: 960px) {
    &:hover {
      background-color: #00aff0 !important;
      background-image: linear-gradient(#00a9e6,#037aa6) !important;
    }
  }
}

@media screen and (min-width: 374px) {
  #KambiBC-container .KambiBC-bonus-offers__content {
    padding: 0 !important;
  }
  
  #KambiBC-container .KambiBC-bonus-offers__wrapper {
    margin-top: 0 !important;
  }
}

@media (min-width: ${1240 / 16}em) {
  #KambiBC-container .KambiBC-bonus-offers__content {
    padding-right: 8px !important;
  }
}

${/** Kambi live event score and name alignment fix */ ''}
.KambiBC-event-item .KambiBC-event-item__score-container .KambiBC-event-item__result-container {
  height: 38px !important;
}

.KambiBC-event-result__points {
  font-weight: 500 !important;
}

@media screen and (min-width: 1280) {
  .KambiBC-scoreboard-football {
    display: none;
  }
}
${/** temp override as kambi does not pass vendor prefix */ ''}
#mod-KambiBC-betslip-container .mod-KambiBC-betslip__rewards-container .KambiBC-react-collapsable-container__header {
  align-content: center;
  -webkit-align-items: center
}

.KambiBC-container#KambiBC-container .KambiBC-event-page-component__columns .KambiBC-landing-page-feed-card__header, 
.KambiBC-container#KambiBC-container .KambiBC-event-page-component__scoreboard-container-top .KambiBC-landing-page-feed-card__header {
  color: ${({ theme }): string => theme.blue13};
}

/* FIXME: not working */
#mod-KambiBC-betslip-container .mod-KambiBC-betslip__outer-wrapper {
  @media screen and (min-width: 960px) {
    bottom: initial !important;
  }
}

.KambiBC-container#KambiBC-container .KambiBC-event-page-component__tabs-container--1 .KambiBC-tabs__tab {
  line-height: 37px !important;
}

.KambiBC-container#KambiBC-container .KambiBC-dropdown__options.KambiBC-dropdown__options--betoffer-category-selection {
  border-radius: 0 !important;
  box-shadow: 0 0 8px 0 rgba(#000, .15) !important;

  @media screen and (min-width: 1280px) {
    right: 294px !important;
    top: 36px !important;
  }
}

#KambiBC-container .KambiBC-dropdown__option {
  height: 40px !important;
  padding: 0 8px !important;
  font-size: 14px !important;
  line-height: 40px !important;
  color: ${({ theme }): string => theme.blue13} !important;
  &:hover {
      background-color: ${({ theme }): string => theme.grey01} !important;
  }
}

#KambiBC-container .KambiBC-dropdown__option--selected {
  background-color: ${({ theme }): string => theme.grey01} !important;
}

.KambiBC-event-page-component__widgets-before-betoffers {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
} 

#KambiBC-container .KambiBC-core-ux-landing-page > :first-child {
  margin-top: 0 !important;
  padding: 0 4px !important;
  
  @media (min-width: 960px) {
    padding: 0 16px !important;
  }
}

#KambiBC-container .KambiBC-league-highlight-header {
  display: none !important;
}

@media screen and (max-width: 376px) {
  #KambiBC-container .KambiBC-filtered-event-list {
    padding: 0 !important;
  }
}

`;

const ThemeProvider: React.FC = (props) => {
  const { children } = props;

  return (
    <>
      <GlobalStyles />
      <StyledThemeProvider theme={theme}>
        <KambiOverrides />
        {children}
      </StyledThemeProvider>
    </>
  );
};

export default ThemeProvider;
